/* Lensmate theme JS */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var f = (window.LM && LM.money) || '£{{amount}}';
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
  }
  window.LMmoney = money;

  function toast(msg) {
    var t = $('#lm-toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /* Drawers */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = $('button, a, input', $('.drawer__panel', d)); if (f) f.focus();
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-drawer]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-open-drawer')); return; }
    if (e.target.closest('[data-close-drawer]')) { closeDrawers(); return; }
    var c = e.target.closest('[data-open-cart]');
    if (c && LM.cartType === 'drawer' && document.getElementById('cart-drawer')) { e.preventDefault(); openDrawer('cart-drawer'); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawers(); closeMegas(); } });

  /* Mega menu */
  function closeMegas(except) {
    $$('.header-nav__item.is-open').forEach(function (li) { if (li !== except) { li.classList.remove('is-open'); var b = $('.header-nav__link', li); if (b) b.setAttribute('aria-expanded', 'false'); } });
  }
  $$('.header-nav__item[data-mega]').forEach(function (li) {
    var btn = $('.header-nav__link', li), t;
    var hover = window.matchMedia('(hover:hover)').matches;
    var open = function () { clearTimeout(t); closeMegas(li); li.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
    btn.addEventListener('click', function (e) {
      if (btn.tagName === 'A') { if (hover || li.classList.contains('is-open')) return; e.preventDefault(); open(); return; }
      li.classList.contains('is-open') ? closeMegas() : open();
    });
    if (window.matchMedia('(hover:hover)').matches) {
      li.addEventListener('mouseenter', function () { t = setTimeout(open, 80); });
      li.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(function () { li.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }, 120); });
    }
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('.header-nav')) closeMegas(); });

  /* Mobile USP bar: rotate one message at a time */
  (function () {
    var items = $$('.usp-bar__i'); if (items.length < 2) return;
    var i = 0; items[0].classList.add('is-on');
    setInterval(function () {
      if (window.innerWidth > 900) return;
      items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on');
    }, 3200);
  })();

  if (window.innerWidth < 600) $$('[data-ph-short]').forEach(function (i) { i.placeholder = i.getAttribute('data-ph-short'); });

  /* Countdowns */
  function tick() {
    $$('[data-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-countdown') + 'T00:00:00');
      var ms = target - new Date();
      if (isNaN(ms)) return;
      if (ms < 0) { el.closest('[data-countdown-wrap]') ? el.closest('[data-countdown-wrap]').style.display = 'none' : (el.style.display = 'none'); return; }
      var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4);
      var D = $('[data-d]', el), H = $('[data-h]', el), M = $('[data-m]', el);
      if (D) D.textContent = d; if (H) H.textContent = ('0' + h).slice(-2); if (M) M.textContent = ('0' + m).slice(-2);
    });
    $$('[data-days-to]').forEach(function (el) {
      var ms = new Date(el.getAttribute('data-days-to') + 'T00:00:00') - new Date();
      el.textContent = ms > 0 ? Math.ceil(ms / 864e5) : '0';
    });
  }
  tick(); setInterval(tick, 30000);

  /* Dispatch countdown (UK time, Mon-Fri) */
  function ukNow() {
    try {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour12: false, weekday: 'short', hour: '2-digit', minute: '2-digit' }).formatToParts(new Date());
      var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
      return { wd: o.weekday, h: parseInt(o.hour, 10) % 24, m: parseInt(o.minute, 10) };
    } catch (e) { var d = new Date(); return { wd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()], h: d.getHours(), m: d.getMinutes() }; }
  }
  function addWorkingDays(n) {
    var d = new Date(); var added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); var g = d.getDay(); if (g !== 0 && g !== 6) added++; }
    return d;
  }
  function fmt(d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
  function dispatch() {
    var el = $$('[data-dispatch]'); if (!el.length) return;
    var cut = (LM.cutoff || '14:00').split(':'); var ch = parseInt(cut[0], 10), cm = parseInt(cut[1] || 0, 10);
    var cutLabel = (ch % 12 || 12) + (cm ? '.' + (cm < 10 ? '0' : '') + cm : '') + (ch < 12 ? 'am' : 'pm');
    var n = ukNow(); var weekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(n.wd) > -1;
    var mins = (ch * 60 + cm) - (n.h * 60 + n.m);
    el.forEach(function (e) {
      var title = $('[data-dispatch-title]', e), sub = $('[data-dispatch-sub]', e);
      if (weekday && mins > 0) {
        var hh = Math.floor(mins / 60), mm = mins % 60;
        title.textContent = 'Order in ' + (hh ? hh + 'h ' : '') + mm + 'm and it goes out today';
      } else {
        title.textContent = 'Order now for dispatch next working day';
      }
      if (sub) sub.textContent = 'Same day dispatch on orders before ' + cutLabel + ', Monday to Friday';
    });
    var nd = weekday && mins > 0 ? addWorkingDays(1) : addWorkingDays(2);
    var sd = weekday && mins > 0 ? addWorkingDays(3) : addWorkingDays(4);
    $$('[data-eta-next]').forEach(function (e) { e.textContent = 'Get it ' + fmt(nd); });
    $$('[data-eta-std]').forEach(function (e) { e.textContent = 'Get it by ' + fmt(sd); });
  }
  dispatch(); setInterval(dispatch, 60000);

  /* Cart */
  function refreshCart(open) {
    return fetch(LM.routes.root.replace(/\/$/, '') + '/?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var html = s['cart-drawer']; if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = $('#cart-drawer', tmp), cur = $('#cart-drawer');
        if (fresh && cur) {
          $$('[data-cart-part]', fresh).forEach(function (p) { var t = $('[data-cart-part="' + p.getAttribute('data-cart-part') + '"]', cur); if (t) t.innerHTML = p.innerHTML; });
          var ff = $('[data-cart-foot]', fresh), cf = $('[data-cart-foot]', cur); if (ff && cf) cf.hidden = ff.hidden;
          cur.setAttribute('data-est-total', fresh.getAttribute('data-est-total') || '');
          window.LMjustAdded = [];
          var body = $('.drawer__body', cur); if (body) body.scrollTop = 0;
        }
        $$('.header-bag').forEach(function (b) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); });
        return fetch(LM.routes.cart_url + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        $$('[data-cart-count]').forEach(function (e) { e.textContent = cart.item_count; });
        var dr = $('#cart-drawer'); var est = dr && dr.getAttribute('data-est-total') ? parseInt(dr.getAttribute('data-est-total'), 10) : cart.total_price;
        $$('[data-cart-total]').forEach(function (e) { e.textContent = ' · ' + money(est); });
        if (open) { if (LM.cartType === 'drawer' && $('#cart-drawer')) openDrawer('cart-drawer'); else window.location = LM.routes.cart_url; }
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
  }
  window.LMrefreshCart = refreshCart;
  function addItems(items, btn) {
    if (btn) { btn.disabled = true; btn._t = btn.innerHTML; btn.textContent = 'Adding…'; }
    window.LMjustAdded = items.map(function (i) { return String(i.id); });
    return fetch(LM.routes.cart_add_url + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshCart(true); })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Sorry, that could not be added'); return refreshCart(true); })
      .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = btn._t; } });
  }
  window.LMadd = addItems;
  function changeLine(line, qty) {
    return fetch(LM.routes.cart_change_url + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function () { return refreshCart(false); });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]');
    if (q) { e.preventDefault(); addItems([{ id: parseInt(q.getAttribute('data-quick-add'), 10), quantity: 1 }], q); return; }
    var ch = e.target.closest('.cart-line [data-qty-change]');
    if (ch) { var w = ch.closest('[data-line]'); var inp = $('input', w); var v = Math.max(0, parseInt(inp.value, 10) + parseInt(ch.getAttribute('data-qty-change'), 10)); changeLine(parseInt(w.getAttribute('data-line'), 10), v); return; }
    var rm = e.target.closest('[data-remove]');
    if (rm) { changeLine(parseInt(rm.getAttribute('data-remove'), 10), 0); }
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-line-input]');
    if (i) changeLine(parseInt(i.getAttribute('data-line-input'), 10), Math.max(0, parseInt(i.value, 10) || 0));
  });

  /* Product page */
  $$('[data-product]').forEach(function (root) {
    var data = JSON.parse($('[data-product-json]', root).textContent);
    var variantSelect = $('[name="id"]', root);
    var qtyInput = $('[data-qty]', root);
    var atc = $('[data-atc]', root);
    var totalEls = $$('[data-atc-total]', document);
    var priceEl = $('[data-price]', root);
    var tierInputs = $$('[data-tier]', root);
    var addons = $$('[data-addon]', root);

    function currentVariant() {
      var id = parseInt(variantSelect.value, 10);
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) return data.variants[i];
      return data.variants[0];
    }
    function tierPrice() {
      var on = tierInputs.filter(function (t) { return t.checked; })[0];
      if (on) return { qty: parseInt(on.value, 10), price: parseInt(on.getAttribute('data-price'), 10) };
      var q = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      return { qty: q, price: currentVariant().price * q };
    }
    function addonTotal() {
      return addons.reduce(function (s, a) { return s + (a.getAttribute('aria-pressed') === 'true' ? parseInt(a.getAttribute('data-price'), 10) : 0); }, 0);
    }
    function update() {
      var v = currentVariant();
      var t = tierPrice();
      tierInputs.forEach(function (t2) { t2.closest('.tier').classList.toggle('is-on', t2.checked); });
      var qh = $('[data-qty-hidden]', root); if (qh) qh.value = t.qty;
      var total = t.price + addonTotal();
      totalEls.forEach(function (e) { e.textContent = money(total); });
      if (priceEl) priceEl.textContent = money(v.price);
      var k = $('[data-klarna]', root); if (k) k.textContent = money(Math.ceil(t.price / 3));
      var ls = $('[data-lowstock]', root);
      if (ls) {
        var q = v.stock;
        var show = v.available && q !== null && q !== undefined && q > 0 && q < 5;
        ls.hidden = !show;
        if (show) {
          ls.classList.toggle('lowstock--last', q === 1); ls.classList.toggle('lowstock--urgent', q === 2);
          $('[data-lowstock-text]', ls).textContent = q === 1 ? 'Last one in stock' : q === 2 ? 'Hurry, only 2 left in stock' : 'Low stock: only ' + q + ' left';
        }
      }
      var avail = v.available;
      $$('[data-atc]', document).forEach(function (b) { b.disabled = !avail; $('[data-atc-label]', b).textContent = avail ? 'Add to bag' : 'Sold out'; });
      var fs = $('[data-freeship]', root);
      if (fs && LM.freeShip > 0) {
        var gap = LM.freeShip - total;
        $('[data-freeship-text]', fs).innerHTML = gap > 0 ? 'Add <strong>' + money(gap) + '</strong> more for free UK delivery' : '<strong>You’ve unlocked free UK delivery</strong>';
        $('[data-freeship-bar]', fs).style.width = Math.min(100, Math.round(total / LM.freeShip * 100)) + '%';
      }
      var aa = $('[data-addall]', root);
      if (aa) { var all = addons.length && addons.every(function (a) { return a.getAttribute('aria-pressed') === 'true'; }); aa.textContent = all ? 'Remove all' : aa.getAttribute('data-label'); }
    }
    tierInputs.forEach(function (t) { t.addEventListener('change', update); });
    if (variantSelect) variantSelect.addEventListener('change', function () {
      update();
      var v = currentVariant();
      if (v.featured_media_id) { var th = $('[data-media-id="' + v.featured_media_id + '"]', root); if (th) th.click(); }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url.toString());
    });
    $$('[data-option-btn]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-option-btn]', root).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true'); variantSelect.value = b.getAttribute('data-option-btn'); variantSelect.dispatchEvent(new Event('change'));
      });
    });
    if (qtyInput) {
      $$('[data-qty-btn]', root).forEach(function (b) { b.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-qty-btn'), 10)); update(); }); });
      qtyInput.addEventListener('change', update);
    }
    addons.forEach(function (a) {
      a.addEventListener('click', function () { a.setAttribute('aria-pressed', a.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); a.textContent = a.getAttribute('aria-pressed') === 'true' ? 'Added ✓' : '+ Add'; update(); });
      var row = a.closest('.addon');
      $$('[data-addon-variant]', row).forEach(function (sw) {
        sw.addEventListener('click', function () {
          $$('[data-addon-variant]', row).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          sw.setAttribute('aria-pressed', 'true');
          a.setAttribute('data-variant', sw.getAttribute('data-addon-variant'));
          a.setAttribute('data-price', sw.getAttribute('data-price'));
          var pr = $('.addon__price', row); if (pr) pr.textContent = money(parseInt(sw.getAttribute('data-price'), 10));
          update();
        });
      });
    });
    var aa = $('[data-addall]', root);
    if (aa) aa.addEventListener('click', function () {
      var all = addons.every(function (a) { return a.getAttribute('aria-pressed') === 'true'; });
      addons.forEach(function (a) { a.setAttribute('aria-pressed', all ? 'false' : 'true'); a.textContent = all ? '+ Add' : 'Added ✓'; });
      update();
    });
    function submit(btn) {
      var t = tierPrice();
      var items = [{ id: currentVariant().id, quantity: t.qty }];
      addons.forEach(function (a) { if (a.getAttribute('aria-pressed') === 'true') items.push({ id: parseInt(a.getAttribute('data-variant'), 10), quantity: 1 }); });
      addItems(items, btn);
    }
    $$('[data-atc]', document).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); submit(b); }); });

    /* Gallery */
    var main = $('[data-gallery-main]', root);
    var thumbs = $$('[data-thumb]', root);
    var idx = 0;
    function show(i) {
      if (!thumbs.length) return;
      idx = (i + thumbs.length) % thumbs.length;
      var th = thumbs[idx];
      var img = $('img', main);
      img.src = th.getAttribute('data-full'); img.srcset = th.getAttribute('data-srcset') || ''; img.alt = th.getAttribute('data-alt') || '';
      thumbs.forEach(function (x, j) { x.setAttribute('aria-current', j === idx ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var pv = $('[data-gallery-prev]', root), nx = $('[data-gallery-next]', root);
    if (pv) pv.addEventListener('click', function () { show(idx - 1); });
    if (nx) nx.addEventListener('click', function () { show(idx + 1); });
    if (main) {
      var sx = null;
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1)); sx = null; });
    }

    /* Sticky ATC on mobile */
    var sticky = $('[data-sticky-atc]');
    var mainAtc = $('[data-atc]', root);
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(mainAtc);
    }
    update();
  });

  /* Tabs */
  $$('[data-tabs]').forEach(function (w) {
    var tabs = $$('[role="tab"]', w);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = x !== t; });
      });
    });
  });

  /* Collection: load more (all products are rendered in stock first, then sold out) */
  $$('[data-load-grid]').forEach(function (grid) {
    var step = parseInt(grid.getAttribute('data-step'), 10) || 24;
    var items = $$('[data-card]', grid);
    var btn = $('[data-load-more]'); var count = $('[data-load-count]');
    var panel = $('[data-lm-filters]'); var tpl = $('[data-iris-tpl]');
    var ORDER = {
      colour: ['Blue', 'Brown', 'Hazel', 'Green', 'Grey', 'Pink', 'Purple', 'Violet', 'Red', 'Orange', 'Yellow', 'Gold', 'White', 'Black', 'UV glow'],
      coverage: ['Covers dark eyes', 'Natural blend', 'Bold, full colour', 'Full blackout / whiteout'],
      diameter: ['14.0 to 14.2mm (natural size)', '14.4 to 14.6mm (bigger iris)', '16mm (extra big)'],
      price: ['Under £3', '£3 to £5', 'Under £5', '£5 to £10', '£12.99 lenses', '£10 and over', 'Over £13'],
      style: ['Plain colour', 'Metallic', 'Diamond', 'Patterned', 'Fruit', 'Animals', 'Plants', 'Disney'],
      accolour: ['Black', 'White', 'Silver', 'Gold', 'Rose gold', 'Yellow', 'Green', 'Turquoise', 'Blue', 'Purple', 'Pink'],
      stock: ['In stock', 'Sold out']
    };
    var DOT = { Black: '#1a1a1a', White: '#fff', Silver: 'linear-gradient(135deg,#e6e6e6,#9a9a9a)', Gold: 'linear-gradient(135deg,#f3d27a,#b8862b)', 'Rose gold': 'linear-gradient(135deg,#f4c6b8,#c57f6c)', Yellow: '#f6d32d', Green: '#4caf50', Turquoise: '#2ec4c6', Blue: '#3b7dd8', Purple: '#8e5bd6', Pink: '#f28cb8' };
    var groups = panel ? $$('[data-f-group]', panel).map(function (g) { return g.getAttribute('data-f-group'); }) : [];
    var sel = {}; groups.forEach(function (g) { sel[g] = []; });
    var vals = function (el, g) { var v = el.getAttribute('data-f-' + g) || ''; return v ? v.split('|') : []; };
    try { var q = new URLSearchParams(location.search); groups.forEach(function (g) { var v = q.get('f_' + g); if (v) sel[g] = v.split(','); }); } catch (e) {}
    function matches(el, skip) {
      return groups.every(function (g) { if (g === skip || !sel[g].length) return true; var v = vals(el, g); return sel[g].some(function (s) { return v.indexOf(s) > -1; }); });
    }
    var shown = step;
    function buildPanel() {
      if (!panel) return;
      groups.forEach(function (g) {
        var box = $('[data-f-group="' + g + '"]', panel), opts = $('[data-f-opts]', box);
        var counts = {}, all = {};
        items.forEach(function (el) { var ok = matches(el, g); vals(el, g).forEach(function (v) { all[v] = 1; if (ok) counts[v] = (counts[v] || 0) + 1; }); });
        var keys = Object.keys(all);
        var ord = ORDER[g];
        keys.sort(function (a, b) { if (ord) { var ia = ord.indexOf(a), ib = ord.indexOf(b); return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib); } return (counts[b] || 0) - (counts[a] || 0) || a.localeCompare(b); });
        box.hidden = keys.length < (g === 'stock' ? 2 : 1) || (keys.length === 1 && g !== 'colour' && g !== 'coverage');
        opts.innerHTML = '';
        keys.forEach(function (k) {
          var c = counts[k] || 0, on = sel[g].indexOf(k) > -1;
          var el;
          if (g === 'colour') {
            el = document.createElement('button'); el.type = 'button'; el.className = 'f-sw'; el.setAttribute('aria-pressed', on ? 'true' : 'false');
            var ir = tpl && tpl.content.querySelector('[data-iris-for="' + k + '"]');
            el.innerHTML = (ir ? ir.innerHTML : '') + '<span>' + k + '</span><small>' + c + '</small>';
            if (!c && !on) el.disabled = true;
            el.addEventListener('click', function () { toggle(g, k); });
          } else {
            el = document.createElement('label'); el.className = 'check'; if (!c && !on) el.style.opacity = '.45';
            var inp = document.createElement('input'); inp.type = 'checkbox'; inp.checked = on; inp.disabled = !c && !on;
            inp.addEventListener('change', function () { toggle(g, k); });
            el.appendChild(inp);
            if (g === 'accolour' && DOT[k]) { var dot = document.createElement('i'); dot.className = 'f-dot'; dot.style.background = DOT[k]; el.appendChild(dot); }
            var sp = document.createElement('span'); sp.textContent = k; el.appendChild(sp);
            var ct = document.createElement('span'); ct.className = 'count'; ct.textContent = c; el.appendChild(ct);
          }
          opts.appendChild(el);
        });
      });
      var act = $('[data-f-active]'); if (act) { act.innerHTML = ''; groups.forEach(function (g) { sel[g].forEach(function (k) { var b = document.createElement('button'); b.type = 'button'; b.textContent = k + ' ✕'; b.addEventListener('click', function () { toggle(g, k); }); act.appendChild(b); }); }); }
    }
    function toggle(g, k) {
      var i = sel[g].indexOf(k); if (i > -1) sel[g].splice(i, 1); else sel[g].push(k);
      shown = step; apply(); syncUrl();
    }
    function syncUrl() {
      try { var u = new URL(location.href); groups.forEach(function (g) { if (sel[g].length) u.searchParams.set('f_' + g, sel[g].join(',')); else u.searchParams.delete('f_' + g); }); history.replaceState(null, '', u.toString()); } catch (e) {}
    }
    function apply() {
      var vis = items.filter(function (el) { return matches(el); });
      items.forEach(function (el) { el.hidden = true; });
      vis.forEach(function (el, i) { el.hidden = i >= shown; });
      if (count) count.textContent = vis.length ? 'Showing ' + Math.min(shown, vis.length) + ' of ' + vis.length : '';
      if (btn) btn.hidden = shown >= vis.length;
      var fc = $('[data-f-count]'); if (fc) fc.textContent = vis.length + ' product' + (vis.length === 1 ? '' : 's');
      var em = $('[data-f-empty]'); if (em) em.hidden = vis.length > 0;
      buildPanel();
    }
    $$('[data-f-clear]').forEach(function (b) { b.addEventListener('click', function () { groups.forEach(function (g) { sel[g] = []; }); shown = step; apply(); syncUrl(); }); });
    if (btn) btn.addEventListener('click', function () { shown += step; apply(); });
    apply();
  });

  /* Filters: submit on change */
  $$('[data-filter-form]').forEach(function (f) {
    f.addEventListener('change', function () {
      var p = new URLSearchParams(new FormData(f));
      var clean = new URLSearchParams();
      p.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
      window.location.search = clean.toString();
    });
  });
  $$('[data-toggle-filters]').forEach(function (b) { b.addEventListener('click', function () { var f = $('.filters'); if (f) f.classList.toggle('is-open'); }); });

  /* Shade finder */
  $$('[data-finder]').forEach(function (w) {
    var btns = $$('[data-eye]', w);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        $$('[data-rec]', w).forEach(function (r) { r.hidden = r.getAttribute('data-rec') !== b.getAttribute('data-eye'); });
      });
    });
  });

  /* Instagram: show our fallback grid if the Instafeed app hasn't filled the feed */
  $$('[data-insta]').forEach(function (w) {
    var feed = $('#insta-feed', w), fb = $('[data-insta-fallback]', w);
    if (!feed || !fb) return;
    setTimeout(function () { if (!feed.children.length && !feed.textContent.trim()) { fb.hidden = false; feed.style.display = 'none'; } }, 3500);
  });
})();

/* Lensmate Hub & articles */
(function () {
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function slug(t) { return t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60); }
  // Table of contents from h2s
  $$('[data-article]').forEach(function (root) {
    var toc = root.querySelector('[data-toc]'); if (!toc) return;
    var hs = $$('.abody__main h2', root); if (hs.length < 3) return;
    var links = [];
    hs.forEach(function (h) {
      if (!h.id) h.id = slug(h.textContent);
      var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.getAttribute('data-toc-label') || h.textContent.replace(/[+]$/, '').trim();
      toc.appendChild(a); links.push([h, a]);
    });
    toc.hidden = false;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) links.forEach(function (l) { l[1].classList.toggle('is-on', l[0] === e.target); }); }); }, { rootMargin: '-20% 0px -70% 0px' });
      links.forEach(function (l) { io.observe(l[0]); });
    }
  });
  // Reading progress
  var bar = document.querySelector('[data-read-progress]'), art = document.querySelector('.apost');
  if (bar && art) {
    var upd = function () { var r = art.getBoundingClientRect(); var p = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - window.innerHeight))); bar.style.width = (p * 100) + '%'; };
    window.addEventListener('scroll', upd, { passive: true }); upd();
  }
  // Copy link
  $$('[data-copy-link]').forEach(function (b) { b.addEventListener('click', function () { if (navigator.clipboard) navigator.clipboard.writeText(location.href.split('#')[0]); b.setAttribute('aria-label', 'Link copied'); b.style.borderColor = '#5B34F0'; }); });
  // Stepper
  $$('[data-stepper]').forEach(function (st) {
    var panels = $$('[data-step-panel]', st), dots = $$('[data-step-dot]', st), i = 0;
    var prev = st.querySelector('[data-step-prev]'), next = st.querySelector('[data-step-next]');
    function go(n) {
      i = Math.max(0, Math.min(panels.length - 1, n));
      panels.forEach(function (p, j) { p.hidden = j !== i; });
      dots.forEach(function (d, j) { d.setAttribute('aria-pressed', j === i ? 'true' : 'false'); d.classList.toggle('is-done', j < i); });
      prev.disabled = i === 0; next.disabled = i === panels.length - 1;
    }
    prev.addEventListener('click', function () { go(i - 1); }); next.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
    go(0);
  });
  // Kit checklist
  $$('[data-kit]').forEach(function (k) {
    var cnt = k.querySelector('[data-kit-count]'), tot = k.querySelector('[data-kit-total]'), btn = k.querySelector('[data-kit-add]');
    function upd() {
      var on = $$('[data-kit-item]', k).filter(function (c) { return c.checked; });
      var sum = on.reduce(function (s, c) { return s + parseInt(c.getAttribute('data-price'), 10); }, 0);
      cnt.textContent = on.length + (on.length === 1 ? ' item' : ' items');
      tot.textContent = window.LMmoney ? LMmoney(sum) : '£' + (sum / 100).toFixed(2);
      btn.disabled = on.length === 0; return on;
    }
    k.addEventListener('change', upd); upd();
    btn.addEventListener('click', function () {
      var items = upd().map(function (c) { return { id: parseInt(c.getAttribute('data-kit-item'), 10), quantity: 1 }; });
      if (items.length && window.LMadd) LMadd(items, btn);
    });
  });
  // Eye colour picker
  $$('[data-eye-picker]').forEach(function (w) {
    var bs = $$('[data-eye]', w), rs = $$('[data-eye-res]', w);
    bs.forEach(function (b) { b.addEventListener('click', function () {
      var v = b.getAttribute('data-eye');
      bs.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      rs.forEach(function (r) { r.hidden = r.getAttribute('data-eye-res') !== v; });
    }); });
  });
})();

/* Title attribute on every link, matching its anchor text (server-side titles are kept) */
(function () {
  function label(a) {
    var t = (a.innerText || a.textContent || '').replace(/\s+/g, ' ').replace(/[→›»]/g, '').trim();
    if (!t) t = a.getAttribute('aria-label') || '';
    if (!t) { var i = a.querySelector('img[alt]'); if (i) t = i.getAttribute('alt'); }
    return t.trim();
  }
  function run(root) {
    var as = (root.querySelectorAll ? root.querySelectorAll('a[href]:not([title])') : []);
    for (var k = 0; k < as.length; k++) { var t = label(as[k]); if (t) as[k].setAttribute('title', t); }
    if (root.matches && root.matches('a[href]:not([title])')) { var t2 = label(root); if (t2) root.setAttribute('title', t2); }
  }
  run(document);
  if ('MutationObserver' in window) new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) run(n); }); }); }).observe(document.body, { childList: true, subtree: true });
})();

/* Recent purchases popup */
(function () {
  var w = document.querySelector('[data-sp]'); if (!w) return;
  try { if (sessionStorage.getItem('lm_sp_off')) return; } catch (e) {}
  var items = Array.prototype.slice.call(w.querySelectorAll('template[data-sp-item]')); if (!items.length) return;
  var slot = w.querySelector('[data-sp-slot]');
  var first = (+w.getAttribute('data-first') || 8) * 1000, show = (+w.getAttribute('data-show') || 6) * 1000, gap = (+w.getAttribute('data-gap') || 18) * 1000;
  for (var i = items.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = items[i]; items[i] = items[j]; items[j] = t; }
  var idx = 0, timer;
  function blocked() {
    var d = document.getElementById('cart-drawer');
    if (d && (d.classList.contains('is-open') || d.getAttribute('aria-hidden') === 'false' || d.hasAttribute('open'))) return true;
    if (document.querySelector('.drawer.is-open, .drawer[open], [data-drawer].is-open')) return true;
    return false;
  }
  function next() {
    if (blocked()) { timer = setTimeout(next, 4000); return; }
    var sticky = document.querySelector('.sticky-atc.is-on'); document.body.classList.toggle('has-sticky-atc', !!sticky);
    slot.innerHTML = ''; slot.appendChild(items[idx % items.length].content.cloneNode(true)); idx++;
    w.hidden = false; requestAnimationFrame(function () { w.classList.add('is-on'); });
    timer = setTimeout(function () { w.classList.remove('is-on'); timer = setTimeout(next, gap); }, show);
  }
  w.querySelector('[data-sp-close]').addEventListener('click', function () {
    clearTimeout(timer); w.classList.remove('is-on'); setTimeout(function () { w.hidden = true; }, 400);
    try { sessionStorage.setItem('lm_sp_off', '1'); } catch (e) {}
  });
  timer = setTimeout(next, first);
})();

/* Product: back in stock swap, cart gift note, predictive search, recently viewed */
(function () {
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var money = window.LMmoney || function (c) { return '£' + (c / 100).toFixed(2); };

  // Back in stock: hide Add to bag when the chosen variant is sold out (Kbite/CartBite button shows instead)
  var pj = $('[data-product-json]');
  if (pj) {
    var data = JSON.parse(pj.textContent), sel = $('select[name="id"]');
    var swap = function () {
      var id = sel ? parseInt(sel.value, 10) : data.variants[0].id;
      var v = data.variants.filter(function (x) { return x.id === id; })[0] || data.variants[0];
      var ctas = $('[data-buy-ctas]'), msg = $('[data-bis-msg]'), sticky = $('.sticky-atc');
      if (ctas) ctas.hidden = !v.available;
      if (msg) msg.hidden = v.available;
      if (sticky) sticky.style.visibility = v.available ? '' : 'hidden';
    };
    if (sel) sel.addEventListener('change', function () { setTimeout(swap, 0); });
    swap();
  }

  // Gift note: save to the cart note as they type
  var nt;
  document.addEventListener('input', function (e) {
    var t = e.target; if (!t.matches || !t.matches('[data-cart-note]')) return;
    clearTimeout(nt);
    nt = setTimeout(function () {
      fetch((window.LM && LM.routes && LM.routes.cart_url ? LM.routes.cart_url : '/cart') + '/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: t.value }) })
        .then(function () { var ok = t.parentNode.querySelector('[data-cart-note-ok]'); if (ok) { ok.hidden = false; setTimeout(function () { ok.hidden = true; }, 1500); } });
    }, 600);
  });

  // Predictive search
  $$('[data-psearch]').forEach(function (form) {
    var input = $('[data-psearch-input]', form), box = $('[data-psearch-results]', form);
    if (!input || !box) return;
    var timer, last = '', ctrl;
    function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function render(q, r) {
      var res = r.resources.results, h = '';
      var ps = res.products || [], cs = res.collections || [], as = res.articles || [];
      if (ps.length) {
        h += '<p class="ps__h">Lenses &amp; products</p>';
        ps.forEach(function (p) {
          h += '<a class="ps__p" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '<span class="ps__ph"></span>') +
            '<span><strong>' + esc(p.title) + '</strong><span' + (p.available ? '>' + esc(money(Math.round(parseFloat(p.price) * 100))) : ' class="ps__so">Sold out, get notified') + '</span></span></a>';
        });
      }
      if (cs.length) { h += '<p class="ps__h">Collections</p>'; cs.forEach(function (c) { h += '<a class="ps__l" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }); }
      if (as.length) { h += '<p class="ps__h">Guides</p>'; as.forEach(function (a) { h += '<a class="ps__l" href="' + esc(a.url) + '">' + esc(a.title) + '</a>'; }); }
      if (!h) h = '<p class="ps__empty">No matches for “' + esc(q) + '”. Try a colour, like blue or grey.</p>';
      h += '<a class="ps__all" href="' + form.action + '?q=' + encodeURIComponent(q) + '">See all results for “' + esc(q) + '”</a>';
      box.innerHTML = h; box.hidden = false; input.setAttribute('aria-expanded', 'true');
    }
    input.addEventListener('input', function () {
      var q = input.value.trim(); clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        if (q === last && !box.hidden) return; last = q;
        if (ctrl && ctrl.abort) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,article&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (r) { if (input.value.trim() === q) render(q, r); }).catch(function () {});
      }, 180);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var items = $$('a', box); if (!items.length || box.hidden) return;
      e.preventDefault();
      var i = items.indexOf(document.activeElement);
      i = e.key === 'ArrowDown' ? Math.min(items.length - 1, i + 1) : i - 1;
      if (i < 0) input.focus(); else items[i].focus();
    });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.focus(); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var items = $$('a', box), i = items.indexOf(document.activeElement); e.preventDefault();
        i = e.key === 'ArrowDown' ? Math.min(items.length - 1, i + 1) : i - 1;
        if (i < 0) input.focus(); else items[i].focus();
      }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length >= 2) { box.hidden = false; } });
  });

  // Recently viewed
  var KEY = 'lm_rv', list = [];
  try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
  var cur = $('[data-rv-current]'), curH = null;
  if (cur) {
    try {
      var c = JSON.parse(cur.textContent); curH = c.h;
      list = [c].concat(list.filter(function (x) { return x.h !== c.h; })).slice(0, 12);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }
  $$('[data-rv]').forEach(function (sec) {
    var items = list.filter(function (x) { return x.h !== curH; }).slice(0, 8);
    if (!items.length) return;
    $('[data-rv-row]', sec).innerHTML = items.map(function (x) {
      return '<a class="rv__c" href="' + esc(x.u) + '">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy">' : '<span class="rv__ph"></span>') + '<strong>' + esc(x.t) + '</strong><span>' + (x.a === false ? 'Sold out' : esc(x.p)) + '</span></a>';
    }).join('');
    sec.hidden = false;
  });
})();

/* Lightbox for "See it on real eyes" */
(function () {
  var items = [], idx = 0, box, img, cap, cnt, lastFocus;
  function build() {
    box = document.createElement('div'); box.className = 'lbx'; box.hidden = true;
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Photo viewer');
    box.innerHTML = '<button class="lbx__btn lbx__close" type="button" aria-label="Close">×</button>' +
      '<button class="lbx__btn lbx__prev" type="button" aria-label="Previous photo">‹</button>' +
      '<figure class="lbx__fig"><img class="lbx__img" alt=""><figcaption class="lbx__cap"></figcaption><a class="lbx__ig" target="_blank" rel="nofollow noopener" hidden><svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg><span></span></a><span class="lbx__count"></span></figure>' +
      '<button class="lbx__btn lbx__next" type="button" aria-label="Next photo">›</button>';
    document.body.appendChild(box);
    img = box.querySelector('.lbx__img'); cap = box.querySelector('.lbx__cap'); cnt = box.querySelector('.lbx__count');
    box.querySelector('.lbx__close').addEventListener('click', close);
    box.querySelector('.lbx__prev').addEventListener('click', function () { show(idx - 1); });
    box.querySelector('.lbx__next').addEventListener('click', function () { show(idx + 1); });
    box.addEventListener('click', function (e) { if (e.target === box || e.target.classList.contains('lbx__fig')) close(); });
    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'Tab') { var f = Array.prototype.slice.call(box.querySelectorAll('button:not([hidden]), a.lbx__ig:not([hidden])')); var i = f.indexOf(document.activeElement); e.preventDefault(); f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus(); }
    });
    var sx = null;
    box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1)); sx = null; });
  }
  function show(i) {
    idx = (i + items.length) % items.length; var it = items[idx];
    img.src = it.getAttribute('data-lightbox'); img.alt = it.getAttribute('data-caption') || '';
    cap.textContent = it.getAttribute('data-caption') || ''; cap.hidden = !cap.textContent;
    var ig = it.getAttribute('data-ig') || '', a = box.querySelector('.lbx__ig');
    if (ig) { a.href = 'https://www.instagram.com/' + encodeURIComponent(ig) + '/'; a.querySelector('span').textContent = '@' + ig; a.title = '@' + ig + ' on Instagram'; a.hidden = false; } else { a.hidden = true; }
    cnt.textContent = items.length > 1 ? (idx + 1) + ' / ' + items.length : '';
    box.querySelector('.lbx__prev').hidden = box.querySelector('.lbx__next').hidden = items.length < 2;
  }
  function open(group, el) {
    if (!box) build();
    items = Array.prototype.slice.call(group.querySelectorAll('[data-lightbox]'));
    lastFocus = el; show(items.indexOf(el));
    box.hidden = false; document.body.classList.add('lbx-open');
    requestAnimationFrame(function () { box.classList.add('is-on'); });
    box.querySelector('.lbx__close').focus();
  }
  function close() {
    box.classList.remove('is-on'); document.body.classList.remove('lbx-open');
    setTimeout(function () { box.hidden = true; img.removeAttribute('src'); }, 220);
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-lightbox]'); if (!el) return;
    e.preventDefault(); open(el.closest('[data-lightbox-group]') || document, el);
  });

  /* FAQ accordions: opening one closes the others in the same list */
  document.addEventListener('toggle', function (e) {
    var d = e.target; if (!d.open || !d.matches || !d.matches('details.faq, details.afaq__q')) return;
    var box = d.parentElement; if (!box) return;
    Array.prototype.forEach.call(box.querySelectorAll(':scope > details.faq, :scope > details.afaq__q'), function (o) { if (o !== d && o.open) o.open = false; });
  }, true);
})();
